module.exports = "/_next/static/images/TopCashback_WhiteText-0b2f79119e2a99f92fc664fa8d533b8b.svg";